/**************************************************
 * Nombre:       Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
//import Anuncios from "../Componentes/Anuncios";
//import Categorias from "../Componentes/Categorias";
//import PorQueComprar from "../Componentes/PorQueComprar";
//import Contactos from "../Componentes/Contactos";
//import ExperienciaCultura from "../Componentes/ExperienciaCultura";
//import Testimonios from "../Componentes/Testimonios";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";
//import {useReciboPago} from "../../Modulo_Pasarela_Pagos/Hooks/useReciboPago";
import Producto_Home from "../Componentes/Producto_Home";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import Anuncios from "../Componentes/Anuncios";
import Categorias from "../Componentes/Categorias";
import PorQueComprar from "../Componentes/PorQueComprar";
import Contactos from "../Componentes/Contactos";
import ExperienciaCultura from "../Componentes/ExperienciaCultura";
import Testimonios from "../Componentes/Testimonios";
import {SECCIONES} from "../../Constantes";

const Home = () => {
    const {sCell, masSM} = useResponsive()


    useEffect(() => {
        irArriba()
    }, [])
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            size={12}
        >


            <Grid item container size={12} sx={{justifyContent: 'flex-start', mt: -4}}>
                <Producto_Home/>
            </Grid>

            <Grid id={SECCIONES[0]} item container lg={12} sm={12} xs={12}
                  sx={{justifyContent: 'center', marginTop: -0}}/>

            <Grid item container size={12}
                  sx={{justifyContent: 'flex-start', marginTop: sCell ? -24 : -10}}>
                <Anuncios/>
            </Grid>

            <Grid item container size={12} sx={{justifyContent: 'flex-start', marginTop: masSM ? 12 : 6}}>
                <Categorias/>
            </Grid>


            <Grid item container size={12}
                  sx={{justifyContent: 'flex-start', marginTop: masSM ? 22 : 14}}>
                <PorQueComprar/>
            </Grid>

            <Grid id={'Contactos'} item container size={12}
                  sx={{justifyContent: 'center', marginTop: sCell ? 4 : 0}}/>


            <Grid item container size={12} sx={{justifyContent: 'flex-start', marginTop: masSM ? 20 : 2}}>
                <Contactos/>
            </Grid>


            <Grid item container size={12}
                  sx={{justifyContent: 'flex-start', marginTop: masSM ? 22 : 12}}>
                <ExperienciaCultura/>
            </Grid>


            <Grid id={'Testimonios'} item container size={12}
                  sx={{justifyContent: 'center', marginTop: 0}}/>

            <Grid item container size={12}
                  sx={{justifyContent: 'flex-start', marginTop: masSM ? 18 : 10}}>
                <Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Home    